<script lang="ts" setup>
interface GreenBoxHolderProps {
  active: boolean;
}

defineProps<GreenBoxHolderProps>();
</script>

<template>
  <div class="box" :class="{ 'box--white': active }">
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
.box {
  background-color: rgb(var(--v-theme-secondary-lighten-4));
  padding: 0px 24px;
  width: 100%;
  border-radius: 4px;
  &:deep(.v-label) {
    width: 100%;
  }
}
.box--white {
  background-color: rgb(var(--v-theme-off-white));
}

:deep(.v-label) {
  color: rgb(var(--v-theme-on-surface));
}
</style>
